/**
 * 목록에 찍는 시각 라벨 — **항상 날짜 + 시:분**.
 *
 * 시:분만 쓰면 어제 14:29 와 오늘 14:29 가 같은 글자가 되어 언제 일인지 알 수 없다.
 * 상대 표기("1일 전")는 얼마나 됐는지는 바로 읽히지만 정확한 시각이 사라지는데,
 * 관제에서는 그 시각으로 영상을 되감고 기록을 맞춘다.
 *
 * 그래서 둘 다 남기고, 대신 **날짜를 흐리게** 해 오늘 것이 대부분인 목록에서 날짜가
 * 반복 노이즈가 되지 않게 한다(`timeParts` 를 쓰는 쪽에서 색을 나눈다).
 *
 * 참고: 예전에는 오늘만 시:분을 쓰고 지난 것에만 날짜를 붙였는데, 열 폭이 4rem 이라
 * "7/27 14:29" 가 잘려 나가 결국 구분이 안 됐다. 폭을 주고 항상 같은 형식으로 둔다.
 */
export interface TimeParts {
  /** "07/28" */
  date: string;
  /** "14:29" */
  time: string;
}

const p2 = (n: number) => String(n).padStart(2, "0");

export function timeParts(timestamp: string): TimeParts | null {
  const d = new Date(timestamp);
  if (Number.isNaN(d.getTime())) return null;
  return {
    date: `${p2(d.getMonth() + 1)}/${p2(d.getDate())}`,
    time: `${p2(d.getHours())}:${p2(d.getMinutes())}`,
  };
}

export function timeLabel(timestamp: string): string {
  const t = timeParts(timestamp);
  return t ? `${t.date} ${t.time}` : "";
}

/** "방금" · "23분 전" · "3시간 전" · "2일 전". */
export function timeAgo(ts: string): string {
  const t = new Date(ts).getTime();
  if (!Number.isFinite(t)) return "";
  const diff = Math.max(0, Date.now() - t);
  const min = Math.floor(diff / 60000);
  if (min < 1) return "방금";
  if (min < 60) return `${min}분 전`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}시간 전`;
  return `${Math.floor(hr / 24)}일 전`;
}
